import documentApiClient, { ApiDefinition } from '@documentsApi';
import buildPath from '@tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/documents/document-file-validation/{fileId}']['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getDocumentFileValidationById = async ({ fileId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/documents/document-file-validation/{fileId}', { fileId });
  const response = await documentApiClient.get(path);
  return response.data;
};

export default getDocumentFileValidationById;